import { FC } from 'react';

type Props = {
  object: any;
};

export const DltStatus: FC<Props> = ({ object: _object }) => {
  return null;
};